//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscDollar(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.9899 4.57V2H10.9899V4.55C8.86993 4.83 7.22993 6.22 7.01993 8.03C6.81993 9.72 7.95993 11.9 11.7299 12.96C13.4799 13.45 14.6399 14.16 15.0099 14.96C15.2399 15.45 15.1199 15.91 14.9799 16.21C14.6099 17.01 13.0899 17.72 10.5999 17.41C8.66993 17.17 7.37993 16.02 6.99993 15.64V18.16C8.97993 19.41 10.6199 19.41 10.9899 19.43V22H12.9899V19.38C14.8099 19.12 16.2099 18.3 16.7899 17.05C17.2399 16.09 17.2499 15.05 16.8199 14.12C16.1899 12.74 14.6499 11.7 12.2699 11.03C10.1299 10.43 8.87993 9.36 9.00993 8.25C9.09993 7.44 10.0399 6.55 11.5799 6.48C14.4499 6.37 16.4299 8.21 16.4999 8.28V5.82C15.6499 5.31 14.4499 4.76 12.9899 4.57Z" fill="currentColor" /></svg>;
}
export default IconMiscDollar;